export var addSlash = function (text) {
    var value = text.replace(/[\W\s._-]+/g, '');
    if (value[2] && !value[4]) {
        return value.replace(/(\d{2})(\d+)/, '$1/$2');
    }
    if (value[4]) {
        return value.replace(/(\d{2})(\d{2})(\d+)/, '$1/$2/$3');
    }
    return value;
};
export var addHyphens = function (text) {
    var value = text.replace(/[\W\s._-]+/g, '');
    if (value[4] && !value[9]) {
        return value.replace(/(\d{4})(\d+)/, '$1-$2');
    }
    if (value[9]) {
        return value.replace(/(\d{4})(\d{5})(\d+)/, '$1-$2-$3');
    }
    return value;
};
export var addPhoneHyphens = function (text) {
    var value = text.replace(/[\W\s._-]+/g, '');
    if (value[3] && !value[9]) {
        return value.replace(/(\d{3})(\d+)/, '$1-$2');
    }
    if (value[9]) {
        return value.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
    }
    return value;
};
var checkCharacter = function (char) {
    return !!Number(char) || char === '0' || char === '.';
};
export var formatPretax = function (str) {
    return Number(str
        .split('')
        .filter(function (char) { return checkCharacter(char); })
        .join('')).toString();
};
